import { ActionNode, addEventListener, dispatchActionAttributes, readClickAttributes } from "./utilty";

export const select = (el: ActionNode<HTMLSelectElement>) => {
  const onChange = () => {
    const selected = el.selectedOptions[0];
    if (!selected) return;

    const attr = readClickAttributes(selected);
    if ('type' in attr) return;
    dispatchActionAttributes(el, attr);
  };

  addEventListener(el, "change", onChange);
}
